import React from 'react';
import { GoogleApiWrapper, Map } from 'google-maps-react';

const googleMapStyle = {
  width: '80%',
  height: '120%',
  marginLeft: 'auto',
  marginRight: 'auto',
};

function onZoom(m) {
  console.log('onZoom');
  console.log(m);
  // TODO: Set tilt to 0
}

const MapTraffic = ({ map, google }) => {
  const trafficLayer = new google.maps.TrafficLayer({ map });
  return trafficLayer === null;
};

const GoogleMap = (props) => {
  const {
    markers,
    polylines,
    centerLocation = { lat: null, lng: null },
    google,
    includeTraffic,
    style = {
      position: 'absolute',
      width: '100%',
      height: '60%',
    },
    zoom = 9,
    mapType = null,
    bounds = null,
    enableScrollWheel = false,
    useGoogleMapStyle = true,
  } = props;

  return (
    <div style={style}>
      <Map
        className="mapperMain2"
        google={google}
        style={useGoogleMapStyle ? googleMapStyle : {}}
        initialCenter={centerLocation}
        zoom={zoom}
        maxZoom={19}
        minZoom={5}
        mapType={mapType}
        draggable
        fullscreenControl={false}
        mapTypeControl={false}
        streetViewControl={false}
        disableDoubleClickZoom
        scrollwheel={enableScrollWheel}
        zoomControl
        onZoom_changed={onZoom}
        bounds={bounds}
      >
        {markers}
        {polylines}
        {includeTraffic && <MapTraffic />}
      </Map>
    </div>
  );
};

// Env vars must have prefix REACT_APP
// See: https://medium.com/@tacomanator/environments-with-create-react-app-7b645312c09d
export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
})(GoogleMap);
